import { render, staticRenderFns } from "./paymentCenterPakgConfig.vue?vue&type=template&id=579c6378&"
import script from "./paymentCenterPakgConfig.vue?vue&type=script&lang=js&"
export * from "./paymentCenterPakgConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579c6378')) {
      api.createRecord('579c6378', component.options)
    } else {
      api.reload('579c6378', component.options)
    }
    module.hot.accept("./paymentCenterPakgConfig.vue?vue&type=template&id=579c6378&", function () {
      api.rerender('579c6378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pakgConfig/paymentCenterPakgConfig.vue"
export default component.exports